import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { AcademicPositionResponse } from "../../models/dtos";

export const academicPositionsApi = createApi({
  reducerPath: "academicPositionsApi",
  baseQuery: baseAuthQuery("academicPositions"),
  tagTypes: ["AcademicPosition"],
  endpoints: (builder) => ({
    getAcademicPositions: builder.query<ApiResponse<AcademicPositionResponse[]>, void>({
      query: () => "",
      providesTags: ["AcademicPosition"],
    }),
    updateAcademicPosition: builder.mutation<ApiResponse<AcademicPositionResponse>, Partial<AcademicPositionResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["AcademicPosition"],
    }),
    deleteAcademicPosition: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["AcademicPosition"],
    }),
  }),
});
